import React, { Suspense } from 'react';

const TreatmentAddedAnimationComponent = React.lazy(() => import('./TreatmentAddedAnimation'));

export const TreatmentAddedAnimation = () => (
  <Suspense fallback={null}>
    <TreatmentAddedAnimationComponent />
  </Suspense>
);
